export enum GoogleRecaptchaViewStoreEvent {
  change = 'change',
}
